export default __webpack_public_path__ + "static/media/No.1-3.6952fc6f.jpg";